import { render, staticRenderFns } from "./home_menu.vue?vue&type=template&id=6235447d&scoped=true&"
import script from "./home_menu.vue?vue&type=script&lang=js&"
export * from "./home_menu.vue?vue&type=script&lang=js&"
import style0 from "./home_menu.vue?vue&type=style&index=0&id=6235447d&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6235447d",
  null
  
)

export default component.exports